import { mapPriceField } from '@/shared/utils/priceFormatter';
import { normalizeProductPageUrl } from '@/features/pdp/utils/pdpUrl';
import type { MatchingSet } from '../../domain/models/MatchingSet';
import type { MatchingSetItem } from '../../domain/models/MatchingSetItem';
import type {
  MatchingSetItemDTO,
  MatchingSetListEntryDTO,
  MatchingSetResponseDTO,
} from '../dto/matchingSet.dto';

const DEFAULT_TITLE = 'Frequently bought together';

function adaptMatchingSetItem(
  dto: MatchingSetItemDTO,
  greyRender?: boolean
): MatchingSetItem {
  return {
    designId: dto.designId ?? 0,
    designName: dto.designName ?? '',
    imageUrl: dto.imageUrl ?? '',
    price: mapPriceField(dto.price),
    discountedPrice: mapPriceField(dto.discountedPrice),
    category: dto.category ?? '',
    productPageUrl: normalizeProductPageUrl(dto.productPageUrl),
    greyRender,
  };
}

function mapDesignItemList(entries: MatchingSetListEntryDTO[]): MatchingSetItem[] {
  return entries
    .filter((entry) => entry.designItem != null)
    .map((entry) => adaptMatchingSetItem(entry.designItem!, entry.greyRender));
}

export function matchingSetDtoToMatchingSet(dto: MatchingSetResponseDTO): MatchingSet {
  const designGroup = dto.designGroup;
  return {
    displayTitle: designGroup?.displayTitle?.trim() || DEFAULT_TITLE,
    items: mapDesignItemList(designGroup?.designItemList ?? []),
  };
}
